module.exports = __webpack_public_path__ + "filter.svg";


//////////////////
// WEBPACK FOOTER
// ./~/ag-grid/src/styles/material-icons/filter.svg?color1=%233F51B5&color2=
// module id = 2199
// module chunks = 67